<template>
    <div v-if="innerValue">
        <div v-if="!innerIsReview">
            <v-fade-transition mode="out-in">
                <validation-provider
                    v-slot="{ errors }"
                    :name="label || 'This'"
                    :rules="rules"
                    v-bind="providerProps"
                    v-show="innerShouldShow"
                    :vid="'validate-' + fieldAssignmentId"
                    :ref="'validate' + fieldAssignmentId"
                >
                    <div v-if="innerLabel" class="font-weight-black" v-html="innerLabel"></div>
                    <span
                        class="field-directions"
                        v-if="directions"
                        v-html="directions"
                    ></span>
                    <div id="over" :style="{width:settings.width+settings.widthPad+'px', height:settings.height+settings.heightPad+'px'}">
                        <iframe :src="innerValue" :width="settings.width" :height="settings.height" :style="{left:settings.left+'px', top:settings.top+'px'}"></iframe>
                    </div>
                </validation-provider>
            </v-fade-transition>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="innerValue">
                    <span v-html="innerValue"></span>
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </div>
</template>

<script>
import formMixin from '../formMixin';
import TypeReview from './TypeReview';
// TODO: more validation

export default {
    name: 'TypePreviewLink',
    mixins: [formMixin],
    inheritAttrs: false,
    props: {

    },
    components: {
        TypeReview
    },
    mounted() {
        if( !this.settings.width ) this.settings.width = 471;
        if( !this.settings.height ) this.settings.height = 977;

        const rat = (this.settings.width/this.settings.height).toFixed(3);
        if( rat != 0.482 )
            console.error("Make sure preview link ratio is 0.482. It's set at "+rat);

        this.settings.left = (this.settings.width*0.0403).toFixed(0);
        this.settings.top = (this.settings.height*0.0716).toFixed(0);
        this.settings.widthPad = this.settings.left*2;
        this.settings.heightPad = this.settings.top*2;

        this.fieldLoaded(); // signal to the form we are loaded
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                directions: this.directions,
                persistentHint: true
            };
        },
        rules() {
            return {};
        }
    }
};
</script>

<style lang="scss">
@import '~vuetify/src/styles/main.sass';

#over {
    background-image: url("/media/photos/portal/phone-frame.png");
    background-repeat: no-repeat;
    position: relative;
    background-size: 100% 100%;
    margin: auto;
}

iframe {
    position: relative;
}

</style>
